/**
 * Component configuration
 */
export default {
  dataApi: 'data-js-component'
}
